export const COMMIT_HASH = process.env.COMMIT_HASH || 'HEAD'
